<div class="dcr-panel" *ngIf="dailyCheckins; else noCheckIn">

    <!-- Left: Stress -->
    <div class="dcr-col dcr-col--left">
        <div class="dcr-box">
            <span class="dcr-col__label">Stress</span>

            <ng-container *ngIf="hasStressData; else noStress">
                <div class="dcr-sparkline-wrap">
                    <cdss-weekly-trend-sparkline
                        [points]="stressPoints"
                        [pointLabels]="stressPointLabels"
                        ariaLabel="Stress levels this week">
                    </cdss-weekly-trend-sparkline>
                </div>
                <div class="dcr-stress-summary">
                    <span class="dcr-stress-summary__item">Avg <strong>{{ stressAverageLabel }}</strong></span>
                    <span class="dcr-stress-summary__item">Peak <strong>{{ stressPeakLabel }}</strong></span>
                </div>
            </ng-container>
            <ng-template #noStress>
                <cdss-weekly-state-label state="notRated" text="No stress ratings this week"></cdss-weekly-state-label>
            </ng-template>
        </div>
    </div>

    <!-- Right: Sleep & mood -->
    <div class="dcr-col dcr-col--right">
        <div class="dcr-box">
            <span class="dcr-col__label">{{ sleepMoodTitle }}</span>

            <ul class="dcr-rows">
                <li class="dcr-row">
                    <span class="dcr-row__label">Sleep</span>
                    <span class="dcr-row__value">
                        <ng-container *ngIf="sleepAnswered; else noSleep">{{ sleepLabel }}</ng-container>
                        <ng-template #noSleep>
                            <cdss-weekly-state-label state="notRated" text="No sleep answers this week"></cdss-weekly-state-label>
                        </ng-template>
                    </span>
                </li>
                <li class="dcr-row">
                    <span class="dcr-row__label">Mood</span>
                    <span class="dcr-row__value">
                        <ng-container *ngIf="moodAnswered; else noMood">
                            <cdss-emotion-icon [emoji]="moodEmoji" class="dcr-mood-icon"></cdss-emotion-icon>
                            <span>{{ moodLabel }}</span>
                        </ng-container>
                        <ng-template #noMood>
                            <cdss-weekly-state-label state="notRated" text="No mood answers this week"></cdss-weekly-state-label>
                        </ng-template>
                    </span>
                </li>
                <li class="dcr-row">
                    <span class="dcr-row__label">ED behaviours</span>
                    <span class="dcr-row__value" [ngSwitch]="behavioursState">
                        <cdss-weekly-state-label *ngSwitchCase="'noData'" state="notRated" text="No behaviours reported"></cdss-weekly-state-label>
                        <cdss-weekly-state-label *ngSwitchCase="'nothingToReport'" state="nothingToReport"></cdss-weekly-state-label>
                        <ng-container *ngSwitchCase="'count'">{{ behavioursCountLabel }}</ng-container>
                    </span>
                </li>
            </ul>
        </div>
    </div>

</div>

<ng-template #noCheckIn>
    <div class="dcr-panel dcr-panel--empty">
        <cdss-weekly-state-label state="noCheckIn"></cdss-weekly-state-label>
    </div>
</ng-template>
